const importImage = (fileName) => {
  return require(`assets/images/${fileName}`);
};

const importIcons = (fileName) => {
  return require(`assets/icons/${fileName}`);
};

export const images = {
  logo: importImage("logo.svg"),
  authbg: importImage("authlayoutbg.png"),
  excel: importImage("excel.png"),
};

export const icons = {
  actionmenu: importIcons("actionmenu.svg"),
  actionmenuVertical: importIcons("actionmenuvertical.svg"),
  edit: importIcons("edit.svg"),
  view: importIcons("view.svg"),
  actionedit: importIcons("actionedit.svg"),
  actiondelete: importIcons("actiondelete.svg"),
  key: importIcons("key.svg"),
  close: importIcons("close.svg"),
  eyeOpen: importIcons("eye_opened.svg"),
  eyeClosed: importIcons("eye_closed.svg"),
  dashboard: importIcons("dashboard.svg"),
  user: importIcons("user.svg"),
  order: importIcons("order.svg"),
  product: importIcons("product.svg"),
  search: importIcons("search.svg"),
  customer: importIcons("customer.svg"),
  coupon: importIcons("coupon.svg"),
  blog: importIcons("blog.svg"),
  fitler: importIcons("filter.svg"),
  calender: importIcons("calender.svg"),
  actionView: importIcons("actionView.svg"),
  warning: importIcons("warning.svg"),
  leftArrow: importIcons("leftarrow.svg"),
  newedit: importIcons("newedit.svg"),
  newpause: importIcons("newpause.svg"),
  newplay: importIcons("newplay.svg"),
  refresh: importIcons("refresh.svg"),
  roundedleftarrow: importIcons("roundedleftarrow.svg"),
  roundedrightarrow: importIcons("roundedrightarrow.svg"),
  viewIcon: importIcons("viewIcon.svg"),
  goldmedal: importIcons("goldmedal.svg"),
  upArrow: importIcons("upArrow.svg"),
  downArrow: importIcons("downArrow.svg"),
  userDelete: importIcons("user_delete.png"),
  userReset: importIcons("user_reset.png"),
  liveimg: importIcons("live.png"),
  facebookIcon: importIcons("facebookIcon.svg"),
  instaIcon: importIcons("instaIcon.svg"),
  youtubeIcon: importIcons("youtubeIcon.png"),
  twitterIcon: importIcons("twitterIcon.png"),
  referralshare: importIcons("referralshare.svg"),
  referralcash: importIcons("referralcash.svg"),
  referralearn: importIcons("referralearn.svg"),
  referralreward: importIcons("referralreward.svg"),
  userDownArrow: importIcons("userDownArrow.svg"),
  faqview: importIcons("faqview.svg"),
  faqdelete: importIcons("faqdelete.svg"),
  receiptClose: importIcons("receiptClose.svg"),
  profileIdentity: importIcons("profileIdentity.svg"),
  showroomImg: importIcons("showroomImg.svg"),
  bankShowroomImg: importIcons("BankIcon.svg"),
  addressIcon: importIcons("addressIcon.svg"),
  basicIcon: importIcons("basicIcon.svg"),
  profileIcon: importIcons("profileIcon.svg"),
  familyIcon: importIcons("familyIcon.jpg"),
  profileplusIcon: importIcons("profileplusIcon.svg"),
  HomeIcon: importIcons("HomeIcon.svg"),
  otherIcon: importIcons("otherIcon.svg"),
  workIcon: importIcons("workIcon.svg"),
  referralreportImg: importIcons("referralreportImg.svg"),
  icondownarrow: importIcons("icondownarrow.svg"),
  tick: importIcons("Tick.svg"),
  uploadIcon: importIcons("upload-icon.svg"),
  rightArrowWithoutTail: importIcons("rightArrowWithoutTail.svg"),
  leftArrowWithoutTail: importIcons("leftArrowWithoutTail.svg"),
  rightTriangularArrow: importIcons("rightTriangularArrow.svg"),
  leftTriangularArrow: importIcons("leftTriangularArrow.svg"),
  comingSoon: importIcons("comingsoon.png"),
  sync: importIcons("sync.svg"),
  downloadReport: importIcons("download.svg"),
  duplicateIcon: importIcons("duplicate.svg"),
};

export const dashBoardIcons = {
  dashboardIcon: importImage("DahboardIcons/dashboardIcon.svg"),
  dashBoardHighlight: importImage("DahboardIcons/dashboardHighlight.svg"),
  contentHighlightIcon: importImage("DahboardIcons/contentHighlightIcon.svg"),
  contentManagementIcon: importImage("DahboardIcons/contentManagementIcon.svg"),
  goldRateHighlightIcon: importImage("DahboardIcons/goldRateHighlightIcon.svg"),
  goldRateIcon: importImage("DahboardIcons/goldRateIcon.svg"),
  orderHighlightIcon: importImage("DahboardIcons/orderHighlightIcon.svg"),
  orderManagementIcon: importImage("DahboardIcons/orderManagementIcon.svg"),
  reportingHighlightIcon: importImage(
    "DahboardIcons/reportingHighlightIcon.svg"
  ),
  reportingIcon: importImage("DahboardIcons/reportingIcon.svg"),
  schemeHighlightIcon: importImage("DahboardIcons/schemeHighlightIcon.svg"),
  schemeManagementIcon: importImage("DahboardIcons/schemeManagementIcon.svg"),
  settingsHighlightIcon: importImage("DahboardIcons/settingsHighlightIcon.svg"),
  settingsIcon: importImage("DahboardIcons/settingsIcon.svg"),
  work: importImage("DahboardIcons/work.svg"),
  supportHighlightIcon: importImage("DahboardIcons/supportHighlightIcon.svg"),
  supportManagementIcon: importImage("DahboardIcons/supportManagementIcon.svg"),
  // updationHighlightIcon: importImage("DahboardIcons/updationHighlightIcon.svg"),
  // updationScreenIcon: importImage("DahboardIcons/updationScreenIcon.svg"),
  userHighlightIcon: importImage("DahboardIcons/userHighlightIcon.svg"),
  userManagementIcon: importImage("DahboardIcons/userManagementIcon.svg"),
  customerHighlightIcon: importImage("DahboardIcons/customerHighlightIcon.svg"),
  customerManagementIcon: importImage(
    "DahboardIcons/customerManagementIcon.svg"
  ),
  Settings: importImage("DahboardIcons/Settings.svg"),
  SettingsHighlight: importImage("DahboardIcons/SettingsHighlight.svg"),
  hamburgerIcon: importImage("DahboardIcons/hamburgerIcon.svg"),
  referralHighlight: importImage("DahboardIcons/referralHighlight.svg"),
  referral: importImage("DahboardIcons/referral.svg"),
  deleteRequestHighlight: importImage(
    "DahboardIcons/deleteRequestHighlight.svg"
  ),
  deleteRequest: importImage("DahboardIcons/deleteRequest.svg"),
  receiptreconciliationHighlight: importImage(
    "DahboardIcons/receiptreconciliationHighlight.svg"
  ),
  receiptreconciliation: importImage("DahboardIcons/receiptreconciliation.svg"),
};

export const navbarIcons = {
  logo: importImage("GoldManagementScheme/ThangamayilLogo.svg"),
  profileLogo: importImage("GoldManagementScheme/ProfileLogo.svg"),
};
export const refernPreviewIcons = {
  share: importImage("camapignPreviewIcons/share.svg"),
  wallet: importImage("camapignPreviewIcons/wallate.svg"),

  reward: importImage("camapignPreviewIcons/reward.svg"),

  rupee: importImage("camapignPreviewIcons/rupee.svg"),
};

export const authIcons = {
  eyeShow: importImage("Auth/show.svg"),
  eyeHide: importImage("Auth/hide.svg"),
};

export const commonComponentIcons = {
  dropDown: importImage("CommonComponentIcons/DropDown.svg"),
  dropDownOpen: importImage("CommonComponentIcons/DropDownOpen.svg"),
  userNumber: importImage("CommonComponentIcons/userNumber.svg"),
  editor: importImage("CommonComponentIcons/editor.svg"),
  create: importImage("CommonComponentIcons/CombinedShape.svg"),
  phone: importImage("CommonComponentIcons/phone.svg"),
  mail: importImage("CommonComponentIcons/mail.svg"),
  left: importImage("CommonComponentIcons/left.svg"),
  right: importImage("CommonComponentIcons/right.svg"),
  editPen: importImage("CommonComponentIcons/editField.svg"),
  updatedRefresh: importImage("CommonComponentIcons/updatedRefresh.svg"),
  warningIcon: importImage("CommonComponentIcons/warningIcon.svg"),
  active: importImage("CommonComponentIcons/active.svg"),
  inactive: importImage("CommonComponentIcons/inactive.svg"),
  sort: importImage("CommonComponentIcons/Sortby.svg"),
  graph: importImage("CommonComponentIcons/StatisticsGraph.svg"),
  contentEdit: importImage("CommonComponentIcons/ContentEdit.svg"),
  logout: importImage("CommonComponentIcons/logout.svg"),
  bell: importImage("CommonComponentIcons/Bell.svg"),
  Group: importImage("CommonComponentIcons/Group.svg"),
  CustomDropdown: importImage("CommonComponentIcons/CustomDropdown.svg"),
  TransactionSuccess: importImage(
    "CommonComponentIcons/TransactionSuccess.svg"
  ),
  rewardIcon: importImage("CommonComponentIcons/rewardIcon.svg"),
  // chevronLeft: importImage("CommonComponentIcons/ChevronLeft.svg"),
  // chevronRight: importImage("CommonComponentIcons/ChevronRight.svg"),
};

export const passBookStatementPdfIcons = {
  sgs_weight_footer_line: importImage("passbookStatementPdfimages/red.svg"),
  sgs_amount_footer_line: importImage("passbookStatementPdfimages/grey.svg"),
  fps_amount_footer_line: importImage("passbookStatementPdfimages/green.svg"),
  digigold_footer: importImage("passbookStatementPdfimages/digigoldfooter.svg"),
  waterMark: importImage("passbookStatementPdfimages/Tmj-logo-02-01-01.svg"),
  mainlogo: importImage("passbookStatementPdfimages/Logo-mayil (2).png"),
  tmlfooter: importImage("passbookStatementPdfimages/tmlfooter.svg"),
};

export const offerDetailImg = {
  offer1: importImage("offer1.svg"),
  offer2: importImage("offer2.svg"),
};

export const threeSixtyIcons = {
  openTicket: importImage("SupportTicketIcons/openTicketIcon.svg"),
  oldTicket: importImage("SupportTicketIcons/oldestOpenIcon.svg"),
  closedTicket: importImage("SupportTicketIcons/closedTicketIcon.svg"),
  sms: importImage("SupportTicketIcons/smsIcon.svg"),

  notification: importImage("SupportTicketIcons/Notification.svg"),
  email: importImage("SupportTicketIcons/emailicon.svg"),
};
export const installmentIcons = {
  autoPaySuccess: importImage("installmentIcons/autoPaySuccess.svg"),
  restOfAutoPay: importImage("installmentIcons/restOfAutoPay.svg"),
  autoPayFailed: importImage("installmentIcons/autoPayFailed.svg"),
  afterAutoPayFailedIcon: importImage(
    "installmentIcons/afterAutoPayFailedIcon.svg"
  ),
  dueDateAutoPay: importImage("installmentIcons/dueDateAutoPay.svg"),
  manualPaySuccess: importImage("installmentIcons/manualPaySuccess.svg"),
  restOfManualPay: importImage("installmentIcons/restOfManualPay.svg"),
  dueDateManualPay: importImage("installmentIcons/dueDateManualPay.svg"),
};
